// extracted by mini-css-extract-plugin
export default {"copyright":"midsFooter_copyright__HmhIq","terms":"midsFooter_terms__s3DmA","policyLink":"midsFooter_policyLink__DRgKk"};